import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { LocalStorageService } from '../common-service/local-storage/local-storage.service';
import { PremiumPlanService } from './service/premium-plan.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { FormControl, Validators, FormBuilder, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-plans',
  templateUrl: './plans.component.html',
  styleUrls: ['./plans.component.scss']
})
export class PlansComponent implements OnInit {

  @ViewChild("cardFirst4Digits") cardFirst4DigitsElement: ElementRef;

  @ViewChild("cardSecond4Digits") cardSecond4DigitsElement: ElementRef;

  @ViewChild("cardThird4Digits") cardThird4DigitsElement: ElementRef;

  @ViewChild("cardFourth4Digits") cardFourth4DigitsElement: ElementRef;

  totalUsers = 1;
  totalMonths = 1;
  voucherMessage = ''

  totalAmountToBePaid = 29.90;
  premiumPlanUnitPrice = 29.90;

  customerIdInStorage =  false;

  responseMessage= '';
  premiumPlanSelected =  false;
  customerId: string;

  subscriptionError = false;

  private paymentForm: FormGroup;

  constructor(private premiumPlanService: PremiumPlanService,
              private localStorageService: LocalStorageService,
              private spinnerService: NgxSpinnerService,
              private fb: FormBuilder,
              private router: Router) { }


  ngOnInit() {
      this.customerIdInStorage = this.localStorageService.getCustomerId() === null ? false : true;
      this.customerId = this.localStorageService.getCustomerId() === null ? '' :  this.localStorageService.getCustomerId();
    }

  addRemoveMonths(type: string) {
    if(type === 'add') {
      this.totalMonths = this.totalMonths+1;
    } else if (type === 'remove' && this.totalMonths >= 1) {
        this.totalMonths = this.totalMonths-1;
  }


    console.log(this.totalAmountToBePaid);
    this.totalAmountToBePaid = this.parseRoundOff(this.premiumPlanUnitPrice * this.totalMonths * this.totalUsers);
    //console.log(this.totalMonths);
    console.log(this.totalAmountToBePaid);
  }

 addRemoveUsers(type: string) {
     if(type === 'add') {
        this.totalUsers =this.totalUsers+1;
    } else if (type === 'remove' && this.totalUsers >= 1) {
        this.totalUsers =this.totalUsers-1;
  }

   this.totalAmountToBePaid = this.parseRoundOff(this.premiumPlanUnitPrice * this.totalMonths * this.totalUsers);

   console.log(this.totalAmountToBePaid);
 }

 selectPremiumPlan() {
    this.premiumPlanSelected =  true;
    //this.subscriptionError = false;
    this.buildPaymentForm();

 }

 changePlanDetails() {
    this.subscriptionError = false;
    this.premiumPlanSelected =  false;
 }

  submitPremiumPlanPayment () {
    this.subscriptionError =  false;
    const paymentFormObject = this.paymentForm.value;

    console.log(paymentFormObject);

    const premiumPlanObject = {cardNumber: this.mergeCardNumbers(paymentFormObject),
                              expiry: this.mergeExpiry(paymentFormObject), cvc: paymentFormObject.cvc,
                              couponCode: paymentFormObject.couponCode,
                              totalUsers: paymentFormObject.totalUsers,
                              totalMonths: paymentFormObject.totalMonths,
                              totalPayment: paymentFormObject.totalPayment,
                              customerId: paymentFormObject.customerId};

    console.log(premiumPlanObject);


    this.spinnerService.show();
    this.premiumPlanService.subscribePremiumplan(premiumPlanObject).subscribe(response => {
       let status = response.code;
       console.log(response);
       if (status === '200' || status === 200) {

            this.localStorageService.removeCustomerId();
            this.localStorageService.removeUserType();

            this.subscriptionError = false;
            this.spinnerService.hide();
            this.router.navigate(['payment-success']);


       } else {
             console.log('inside Else part: ');

             this.subscriptionError = true;

             console.log(this.subscriptionError);
             this.responseMessage  = response.message;
             this.spinnerService.hide();
       }
   },
     err => {
       console.log(err);
          this.subscriptionError = true;
          this.spinnerService.hide();
          this.responseMessage  = 'An error occared while subscribe premium plan.';
   });

  }

  buildPaymentForm() {

    this.paymentForm = this.fb.group({
      cardFirst4Digits: ['', [Validators.required, Validators.minLength(4), Validators.maxLength(4), Validators.pattern("^[0-9]*$")]],
      cardSecond4Digits: ['', [Validators.required, Validators.minLength(4), Validators.maxLength(4), Validators.pattern("^[0-9]*$")]],
      cardThird4Digits: ['', [Validators.required, Validators.minLength(4), Validators.maxLength(4), Validators.pattern("^[0-9]*$")]],
      cardFourth4Digits: ['', [Validators.required, Validators.minLength(4), Validators.maxLength(4), Validators.pattern("^[0-9]*$")]],
      expiryMonth: ['',   [Validators.required, Validators.maxLength(2), Validators.minLength(2), Validators.pattern("^[0-9]*$")]],
      expiryYear: ['',   [Validators.required, Validators.maxLength(2), Validators.minLength(2), Validators.pattern("^[0-9]*$")]],
      cvc: ['', [Validators.required, Validators.maxLength(3), Validators.minLength(3), Validators.pattern("^[0-9]*$")]],
      couponCode: [''],
      totalUsers: [this.totalUsers, Validators.required],
      totalMonths: [this.totalMonths, Validators.required],
      totalPayment: [this.numberToString(this.totalAmountToBePaid), Validators.required],
      customerId: [this.customerId, Validators.required]
    });

  }

  beginPayment() {
    console.log(this.paymentForm.value);
  }

  parseRoundOff(num) {
    var decimals = 2;
    var sign = num >= 0 ? 1 : -1;
    return parseFloat((Math.round((num*Math.pow(10,decimals)) + (sign*0.001)) / Math.pow(10,decimals)).toFixed(decimals));
  }

  numberToString (number) {
    return number.toFixed(2)
  }

  isNumberKey(evt){
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if (charCode != 46 && charCode > 31
      && (charCode < 48 || charCode > 57))
      return false;
      return true;
  }

  mergeCardNumbers(paymentFormObject): string{
        return paymentFormObject.cardFirst4Digits + paymentFormObject.cardSecond4Digits +
         paymentFormObject.cardThird4Digits + paymentFormObject.cardFourth4Digits;
  }

  mergeExpiry(paymentFormObject) : string {
      return paymentFormObject.expiryMonth + paymentFormObject.expiryYear;
  }

  applyCouponCode() {

    const paymentFormObject = this.paymentForm.value;

    //const voucherCode = this.paymentForm.value.couponCode;

    const applyVoucherCodeObject = {client: paymentFormObject.customerId,
                                    subscription_package: 2,
                                    no_of_user: paymentFormObject.totalUsers,
                                    no_of_months: paymentFormObject.totalMonths,
                                    cost_before_discount: paymentFormObject.totalPayment,
                                    voucher_code: paymentFormObject.couponCode};
    this.spinnerService.show();
    this.premiumPlanService.applyCouponCode(applyVoucherCodeObject).subscribe(response => {
       let status = response.code;
       console.log(response);
       if (status === '200' || status === 200) {

            this.localStorageService.removeCustomerId();

            this.subscriptionError = false;
            this.spinnerService.hide();
            //this.router.navigate(['payment-success']);


       } else {
             console.log('inside Else part: ');

             this.subscriptionError = true;

             console.log(this.subscriptionError);
             this.responseMessage  = response.message;
             this.spinnerService.hide();
       }
   },
     err => {
       console.log(err);
          this.subscriptionError = true;
          this.spinnerService.hide();
          this.responseMessage  = 'An error occared while apply voucher.';
   });

  }

  applyVoucherCode() {
      this.voucherMessage = '';
      this.spinnerService.show();

      this.voucherMessage = 'Invalid voucher code';

      this.spinnerService.hide();
  }
}



// WEBPACK FOOTER //
// ./src/app/plans/plans.component.ts